import { create } from 'zustand';
import { ApiUtils, CustomerApi, CustomerEntity, RequestStrategyEnum } from '@shared/api';

interface ITransactionCustomerStore {
  loading: boolean;
  error: string | null;
  customer: CustomerEntity | null;
  getCustomer: (customerId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useTransactionCustomerStore = create<ITransactionCustomerStore>((set) => ({
  loading: false,
  error: null,
  customer: null,

  getCustomer: ApiUtils.wrapperApi(async (customerId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null, customer: null });
      const result = await CustomerApi.getCustomer(customerId, signal);
      set({ customer: result ?? null, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ customer: null, loading: false, error: null }),
}));
